module.exports = __webpack_public_path__ + "93cc7aa654ae36b0828716f5ec3159cd.ttf";